import React from "react";
import { FaSearch } from "react-icons/fa";
import BotaoBusca from "../../../components/BotaoBusca.js";

export const AcompanhamentoFiltros = ({
  buscaDigitada,
  setBuscaDigitada,
  executarBusca,
  limparBusca,
  filtroStatus,
  setFiltroStatus,
  contadoresStatus,
  itemSelecionado,
  apenasEmpresaSelecionada,
  setApenasEmpresaSelecionada,
  totalFormulariosEmpresaSelecionada,
  ehUsuarioCiee = false,
  filtroPrograma = "TODOS",
  setFiltroPrograma,
  contadoresPrograma = null,
}) => {
  return (
    <>
      <div className="acompanhamento-busca-wrapper">
        <div className="acompanhamento-input-container">
          <FaSearch className="acompanhamento-icone-busca" />
          <input
            id="acompanhamento-input-busca"
            type="text"
            placeholder="Buscar por CNPJ, Razão social, Nome do Estudante, CPF, Número do convênio, Código da empresa"
            value={buscaDigitada}
            onChange={(e) => setBuscaDigitada(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && executarBusca()}
            className="acompanhamento-input-busca"
          />
          {buscaDigitada && (
            <button
              type="button"
              className="acompanhamento-btn-limpar-busca"
              onClick={limparBusca}
              title="Limpar busca"
            >
              ✕
            </button>
          )}
        </div>
        <BotaoBusca onClick={executarBusca} />
      </div>

      {/* Para perfis CIEE: filtros rápidos de programa (visão multi-página) */}
      {ehUsuarioCiee && contadoresPrograma && setFiltroPrograma && (
        <div
          className="acompanhamento-status-chips acompanhamento-programa-chips"
          style={{ marginBottom: "0.6rem" }}
        >
          <button
            type="button"
            className={`acompanhamento-chip ${filtroPrograma === "TODOS" ? "ativo" : ""}`}
            onClick={() => setFiltroPrograma("TODOS")}
            title="Ver processos de todos os programas"
          >
            Todos os Programas{" "}
            <span className="acompanhamento-chip-count">
              {contadoresPrograma.todos}
            </span>
          </button>

          <button
            type="button"
            className={`acompanhamento-chip ${filtroPrograma === "0" ? "ativo" : ""}`}
            onClick={() => setFiltroPrograma("0")}
            title="Ver apenas processos de Estágio (TCE)"
          >
            Estágio (TCE){" "}
            <span className="acompanhamento-chip-count">
              {contadoresPrograma.tce}
            </span>
          </button>

          <button
            type="button"
            className={`acompanhamento-chip ${filtroPrograma === "1" ? "ativo" : ""}`}
            onClick={() => setFiltroPrograma("1")}
            title="Ver apenas processos de Aprendizagem (TCA)"
          >
            Aprendizagem (TCA){" "}
            <span className="acompanhamento-chip-count">
              {contadoresPrograma.tca}
            </span>
          </button>

          <button
            type="button"
            className={`acompanhamento-chip ${filtroPrograma === "2" ? "ativo" : ""}`}
            onClick={() => setFiltroPrograma("2")}
            title="Ver apenas processos de Aprendizagem CIEEMG Empregador"
          >
            TCA Empregador{" "}
            <span className="acompanhamento-chip-count">
              {contadoresPrograma.tcaEmpregador}
            </span>
          </button>
        </div>
      )}

      {/* Chips de filtro por status de tramitação */}
      <div className="acompanhamento-status-chips">
        <button
          type="button"
          className={`acompanhamento-chip ${filtroStatus === "TODOS" ? "ativo" : ""}`}
          onClick={() => setFiltroStatus("TODOS")}
        >
          Todos{" "}
          <span className="acompanhamento-chip-count">
            {contadoresStatus.todos}
          </span>
        </button>
        <button
          type="button"
          className={`acompanhamento-chip ${filtroStatus === "VALIDACAO" ? "ativo" : ""}`}
          onClick={() => setFiltroStatus("VALIDACAO")}
        >
          Em Validação / Pendentes{" "}
          <span className="acompanhamento-chip-count">
            {contadoresStatus.validacao}
          </span>
        </button>
        <button
          type="button"
          className={`acompanhamento-chip ${filtroStatus === "ASSINATURA" ? "ativo" : ""}`}
          onClick={() => setFiltroStatus("ASSINATURA")}
        >
          Aguardando Assinatura{" "}
          <span className="acompanhamento-chip-count">
            {contadoresStatus.assinatura}
          </span>
        </button>
        <button
          type="button"
          className={`acompanhamento-chip ${filtroStatus === "FINALIZADOS" ? "ativo" : ""}`}
          onClick={() => setFiltroStatus("FINALIZADOS")}
        >
          Finalizados{" "}
          <span className="acompanhamento-chip-count">
            {contadoresStatus.finalizados}
          </span>
        </button>

        {ehUsuarioCiee && itemSelecionado && totalFormulariosEmpresaSelecionada > 0 && (
          <button
            type="button"
            className={`acompanhamento-chip acompanhamento-chip-empresa ${
              apenasEmpresaSelecionada ? "ativo" : ""
            }`}
            onClick={() => setApenasEmpresaSelecionada((prev) => !prev)}
            title={
              apenasEmpresaSelecionada
                ? "Clique para remover o filtro e ver todas as empresas"
                : "Clique para filtrar e ver apenas formulários desta empresa"
            }
          >
            🏢{" "}
            {apenasEmpresaSelecionada
              ? "Apenas desta empresa"
              : "Filtrar por esta empresa"}
            <span className="acompanhamento-chip-count">
              {totalFormulariosEmpresaSelecionada}
            </span>
            {apenasEmpresaSelecionada ? " ✕" : ""}
          </button>
        )}
      </div>
    </>
  );
};

export default AcompanhamentoFiltros;
